import { Link, useLocation } from "react-router-dom";
import { NAV } from "@/constants/testIds";
import { Waveform, Coins, BookOpen } from "@phosphor-icons/react";
import { useI18n } from "@/i18n";
import LanguageSelector from "@/components/LanguageSelector";

export default function Layout({ children }) {
  const loc = useLocation();
  const { t } = useI18n();
  const linkCls = (path) =>
    `px-3 py-1.5 rounded-full text-sm transition-colors ${
      loc.pathname === path
        ? "text-white bg-white/[0.06] border border-white/10"
        : "text-slate-400 hover:text-white"
    }`;

  return (
    <div className="relative z-10">
      <header className="sticky top-0 z-40 backdrop-blur-xl bg-[#080e16]/70 border-b border-white/[0.06]">
        <div className="max-w-7xl mx-auto px-5 md:px-8 h-16 flex items-center justify-between gap-3">
          <Link to="/" data-testid={NAV.logo} className="flex items-center gap-2.5 group">
            <span className="relative flex items-center justify-center h-8 w-8 rounded-lg overflow-hidden">
              <span className="absolute inset-0 bg-gradient-to-br from-orange-500 via-pink-500 to-purple-500" />
              <Waveform weight="bold" className="relative h-4 w-4 text-white" />
            </span>
            <span className="font-display font-semibold text-[15px] tracking-tight">
              U.CENTER <span className="hidden sm:inline text-slate-400 font-normal">{t("brand.tagline")}</span>
            </span>
          </Link>

          <nav className="flex items-center gap-1">
            <Link data-testid={NAV.simulatorLink} to="/simulator" className={linkCls("/simulator")}>
              <span className="inline-flex items-center gap-1.5">
                <Coins weight="duotone" className="h-4 w-4" />
                <span className="hidden sm:inline">{t("nav.simulator")}</span>
              </span>
            </Link>
            <Link data-testid={NAV.rulesLink} to="/rules" className={linkCls("/rules")}>
              <span className="inline-flex items-center gap-1.5">
                <BookOpen weight="duotone" className="h-4 w-4" />
                <span className="hidden sm:inline">{t("nav.rules")}</span>
              </span>
            </Link>
            <div className="ml-1">
              <LanguageSelector compact />
            </div>
          </nav>
        </div>
      </header>

      <main className="relative z-10">{children}</main>

      <footer className="relative z-10 border-t border-white/[0.06] mt-24">
        <div className="max-w-7xl mx-auto px-5 md:px-8 py-8 text-xs text-slate-500 flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
          <div>
            <span className="text-slate-400">Illustrative projection</span> · Not investment advice. Rewards depend on eligible activity, verification & rank.
          </div>
          <div>
            Compensation rules sourced from{" "}
            <a href="https://u.center/docs" target="_blank" rel="noreferrer" className="text-pink-400 hover:text-pink-300 underline decoration-dotted">u.center/docs</a>
          </div>
        </div>
      </footer>
    </div>
  );
}
